export const BASE_URL = 'https://api.aftersales.jetour.com.pk/api' // Production URL
export const SERVICE_LAYER_BASE_URL = 'https://api.aftersales.jetour.com.pk/sap/b1s/v1' // Service Layer URL

// export const BASE_URL = 'https://api.afs.jetour.com.pk:8096/api' // Testing URL
// export const SERVICE_LAYER_BASE_URL = 'https://api.afs.jetour.com.pk:8096/sap/b1s/v1' // Service Layer URL
